import React from 'react'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import IosShareIcon from '@mui/icons-material/IosShare'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined'
import ToolIcon from './ToolIcon'

const HoverActionIcon = ({ icon: Icon, onClick }) => (
    <button
        type='button'
        onClick={(e) => {
            e.stopPropagation()
            onClick?.(e)
        }}
        className='w-5 h-5 inline-flex items-center justify-center bg-white border !border-[#e2e8f0] text-[#6b7280] hover:text-black hover:bg-[#f8fafc] first:rounded-l-md last:rounded-r-md -ml-px first:ml-0'
    >
        <Icon style={{ fontSize: 13 }} />
    </button>
)

const TaskCard = ({
    title,
    description,
    metaLabel,
    tools = [],
    buttonLabel = 'Run this task',
    onClick,
    showActions = true,
    onDelete,
    onShare,
    onEdit,
    onSchedule,
    onPin,
    animationDelay,
}) => {
    return (
        <div
            onClick={onClick}
            style={animationDelay != null ? { animationDelay: `${animationDelay}ms` } : undefined}
            className='task-card-animate group relative border !border-[#e2e8f0] rounded-xl p-4 bg-white transition-colors hover:bg-[#f1f5f9] hover:!border-black cursor-pointer h-full flex flex-col'
        >
            <h3 className='text-[14px] font-[700] text-[#020817]  mb-1'>
                {title}
            </h3>
            <div
                className='text-[12px] text-[#64748b] mb-2 line-clamp-2 overflow-hidden'
                dangerouslySetInnerHTML={{ __html: description || "" }}
            />

            <div className='flex items-end justify-between mt-auto'>
                <div className='flex items-center gap-2'>
                    <span className='text-[11px] text-[#9ca3af]'>
                        {metaLabel}
                    </span>
                    {tools.length > 0 && (
                        <div className='flex items-center gap-1'>
                            {tools.map((tool, i) => (
                                <ToolIcon key={i} type={tool} />
                            ))}
                        </div>
                    )}
                </div>
                <div className='flex flex-col items-end gap-2'>
                    {showActions && (
                        <div className='flex items-center opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none gap-2 group-hover:pointer-events-auto'>
                            <HoverActionIcon icon={DeleteOutlineIcon} onClick={onDelete} />
                            <HoverActionIcon icon={IosShareIcon} onClick={onShare} />
                            <HoverActionIcon icon={EditOutlinedIcon} onClick={onEdit} />
                            <HoverActionIcon icon={AccessTimeIcon} onClick={onSchedule} />
                            <HoverActionIcon icon={PushPinOutlinedIcon} onClick={onPin} />
                        </div>
                    )}
                    <button
                        type='button'
                        onClick={onClick}
                        className='flex items-center font-semibold gap-1 px-5 py-3 rounded-md border !border-[#020817] bg-white text-[12px] text-[#020817] transition-colors group-hover:bg-[#020817] group-hover:text-white group-hover:!border-black relative z-10'
                    >
                        <ArrowForwardIcon style={{ fontSize: 14 }} />
                        {buttonLabel}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default TaskCard
